import { render, staticRenderFns } from "./header-tools.vue?vue&type=template&id=167d4efa&scoped=true"
import script from "./header-tools.vue?vue&type=script&lang=js"
export * from "./header-tools.vue?vue&type=script&lang=js"
import style0 from "./header-tools.vue?vue&type=style&index=0&id=167d4efa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167d4efa",
  null
  
)

export default component.exports